/**
 * Country values must match `communities.country` in Supabase for filtering to work.
 */
export const ONBOARDING_COUNTRIES = [
  { value: 'Australia', label: 'Australia' },
  { value: 'Ireland', label: 'Ireland' },
  { value: 'UK', label: 'UK' },
];

export const ONBOARDING_UI = {
  noCommunitiesForCountry:
    'No communities are available for this country yet. Try another country or contact support.',
};
